// extracted by mini-css-extract-plugin
export default {"Overlay":"gCtUBcT0","isClose":"Qs_dzZk2","isOpen":"A7AsVpXe","isClosing":"K2MNE8TK"};